import axios from "axios";
import { PagedResult } from "../models/paged-result";

export const IMPORTACIONSEMPRE_URL = `ImportacionSempre`;

export const importacionSempreServices = {
  getList: (queryParams: any) => {
    return axios.get<PagedResult>(`${IMPORTACIONSEMPRE_URL}`, {
      params: queryParams,
    });
  },

  confirmar: function (data: any) {
    return axios.post(`${IMPORTACIONSEMPRE_URL}/confirmar`, { practica: data });
  },

  anular: function (data: any) {
    return axios.post(`${IMPORTACIONSEMPRE_URL}/anular`, data);
  },
};
